import { getOrCreateHistoryPopupShowedCookie } from './getOrCreateHistoryPopupShowedCookie';

export function isPopupHistoryExpired(hours: number): boolean {
  const timeNow = Date.now();
  const { timeStarted } = getOrCreateHistoryPopupShowedCookie();

  return (timeNow - timeStarted) / 36e5 >= hours;
}
